import Features from "../uidispatcherapi/Features";
import { FeatureSessionStore } from "../uidispatcherapi/FeatureSessionStore";

export function shouldUseListOverviewScoring(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.LISTPAGE_SORTING_SCORING) === "B";
}

export function useNewAddToCartComponentFromOC(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_NEW_ADD_TO_CART_COMPONENT_FROM_OC) === "B";
}